import { Component, OnInit, Input, Host, Self, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subject } from 'rxjs/Subject';
import { MaterialConfigurationService } from 'app/core/components/workflow-new/material/configurations/material-configuration.service';
import { LicenseService } from 'app/core/services/license.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'itpx-multi-content-deliverable',
  templateUrl: './multi-content-deliverable.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiContentDeliverableComponent extends RxComponent implements OnInit {
  private tileClicked$ = new Subject<void>();
  private renderingResults$: Observable<any>;
  @Input() initState: any;
  @Output() triggerParent = new EventEmitter<any>();
  // private status$: Observable<any>
  private conf: MaterialConfiguration;
  private tagType: string;
  private clickable: boolean;
  private state$ = new ReplaySubject<{ status: string }>(1);
  private stop$ = new Subject<void>();
  private downloadLink: string;
  protected deliverableStatus: any = {};
  // private deliverable$ = new ReplaySubject<any>(1);
  // protected status: string = 'loading';
  protected target: Array<any> = [];
  protected messages: any = {};
  private readonly finished = 'finished';
  private readonly inprogress = 'inprogress';
  private readonly partial = 'partial';
  private readonly invalid = 'invalid';

  constructor(
    private materialConfiguration: MaterialConfigurationService,
    private licenseService: LicenseService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    // this.downloadLink = this.deliverable.googleEmbedLink;
    this.conf = this.materialConfiguration.getConf(this.initState);
    Object.assign(this, this.conf);
    const sourceState$ = new BehaviorSubject<any>(this.initState);
    const allRendering$ = sourceState$.filter(val => this.allRendering(val.contents))
      .switchMap(_ => this.licenseService.checkStatus(this.initState.id)).takeUntil(this.stop$).map(contents => {
        this.initState.contents = contents;
        this.initState.state = this.getPreState(contents);
        return this.initState;
      });
    const noneRendering$ = sourceState$.filter(val => this.noneRendering(val.contents)).map(deliverable => {
      deliverable.state = deliverable.contents.map(content => content.status.configKey).every(status => status === this.invalid) ?
        this.invalid : this.finished;
      return deliverable;
    });
    const someRendering$ = sourceState$.filter(val => this.someRendering(val.contents))
      .switchMap(_ => this.licenseService.checkStatus(this.initState.id)).takeUntil(this.stop$).map(contents => {
        this.initState.contents = contents;
        this.initState.state = this.getPreState(contents);
        return this.initState;
      });
    this.renderingResults$ = Observable.merge(allRendering$, noneRendering$, someRendering$).bindToLifecycle(this).shareReplay(1);
    this.renderingResults$.subscribe(val => {
      if (!this.allRendering(val.contents)) {
        this.clickable = true;
        if (1 === val.contents.length && this.isDonwloadableTag(this.conf.tagType)) {
          this.downloadLink = val.contents[0].googlePresentationEmbedLink || val.contents[0].googleEmbedLink;
          this.conf.links[0].url = val.contents[0].googlePresentationEmbedLink || val.contents[0].googleEmbedLink;
        }
      }
      if (this.noneRendering(val.contents)) {
        this.stop$.next();
      }
    });
  }

  isDonwloadableTag(type: string): boolean {
    return type === 'ebook' || type === 'material';
  }

  isOnlineMaterial(type: string): boolean {
    return type === 'scormcloud' || type === 'scorm' || type === 'video' || type === 'googleslides';
  }

  productLoading(status): boolean {
    return status.toLowerCase() === 'inprogress' || status.toLowerCase() === 'queued';
  }

  productInvalid(status): boolean {
    return status.toLowerCase() === this.invalid;
  }

  getPreState(contents: any[]): string {
    return contents.every(content => this.productLoading(content.status.configKey || content.status)) ? this.inprogress :
      (contents.some(content => this.productLoading(content.status.configKey || content.status)) ? this.partial :
        (contents.every(content => this.productInvalid(content.status.configKey || content.status)) ?
          this.invalid : this.finished))
  }

  private allRendering(contents: any[]): boolean {
    return this.getPreState(contents) === this.inprogress;
  }

  private noneRendering(contents: any[]): boolean {
    return this.getPreState(contents) === this.finished || this.getPreState(contents) === this.invalid;
  }

  private someRendering(contents: any[]): boolean {
    return this.getPreState(contents) === this.partial;
  }

  onClick(event: any) {
    if (!event.target.classList.contains('link') && !event.target.parentElement.classList.contains('link')) {
      if (this.conf.multiContent) {
        let target = event.target;
        while (target.classList && !target.classList.contains('frame') && target.parentElement != null)
          target = target.parentElement;
        if (!target.classList || !target.classList.contains('frame')) {
          this.tileClicked$.next();
        }
      } else if (this.conf.tagType === 'externalLink') {
        // this.licenseService.getExternalContentFileUrl(this.initState.id)
        //   .neverError()
        //   .bindToLifecycle(this)
        //   .subscribe(response =>
        //     window.open(response.data, '_blank')
        //   );
      } else if (this.conf.target)
        this.router.navigate(this.conf.target, { relativeTo: this.route });
      else {
        if (this.conf.classType !== 'Online Exam' && this.conf.classType !== 'AI Proctored Online Exam')
          window.open(this.downloadLink, '_blank', 'noopener,noreferrer');
      }
    }
  }

  onTriggerParent(event: any) {
    this.triggerParent.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/multi-content-deliverable/multi-content-deliverable.component.ts